import { createRouter, createWebHashHistory } from 'vue-router'
import { pageTitle } from './stores/LayoutStore'
import { toast } from '@/ui-plus/sonner';

import HomeView from '@partner-spa-vue/pages/HomeView.vue'
import MyWebsitesView from '@partner-spa-vue/pages/my-websites/MyWebsitesView.vue'
import WebsiteNewForm from '@partner-spa-vue/pages/my-websites/WebsiteNewForm.vue'
import WebsiteLayout from '@partner-spa-vue/layouts/website/WebsiteLayout.vue'
import WebsiteHomeView from '@partner-spa-vue/pages/website/HomeView.vue'
import WebsiteAddressView from '@partner-spa-vue/pages/website/address/AddressView.vue'

import PartnerSupportView from '@partner-spa-vue/pages/website/partner_support/_PartnerSupportView.vue'
import SupportOverviewView from '@partner-spa-vue/pages/website/partner_support/overview/OverviewView.vue'
import SupportStripeView from '@partner-spa-vue/pages/website/partner_support/stripe/StripeView.vue'
import SupportFeeSettingsView from '@partner-spa-vue/pages/website/partner_support/fee-settings/FeeSettingsView.vue'
import SupportBalancesView from '@partner-spa-vue/pages/website/partner_support/balances/BalancesView.vue'
import SupportIncomingView from '@partner-spa-vue/pages/website/partner_support/incoming/IncomingView.vue'
import SupportUnpaidView from '@partner-spa-vue/pages/website/partner_support/unpaid/UnpaidView.vue'
import SupportHistoryView from '@partner-spa-vue/pages/website/partner_support/history/HistoryView.vue'
import SupportNotificationsView from '@partner-spa-vue/pages/website/partner_support/notifications/NotificationsView.vue'
import SupportImprintView from '@partner-spa-vue/pages/website/partner_support/imprint/ImprintView.vue'
import SupportReportsView from '@partner-spa-vue/pages/website/partner_support/reports/ReportsView.vue'

import PartnerMarketingView from '@partner-spa-vue/pages/website/partner_marketing/_PartnerMarketingView.vue'
import MarketingOverviewView from '@partner-spa-vue/pages/website/partner_marketing/overview/OverviewView.vue'
import MarketingStripeView from '@partner-spa-vue/pages/website/partner_marketing/stripe/StripeView.vue'
import MarketingFeeSettingsView from '@partner-spa-vue/pages/website/partner_marketing/fee-settings/FeeSettingsView.vue'
import MarketingBalancesView from '@partner-spa-vue/pages/website/partner_marketing/balances/BalancesView.vue'
import MarketingIncomingView from '@partner-spa-vue/pages/website/partner_marketing/incoming/IncomingView.vue'
import MarketingUnpaidView from '@partner-spa-vue/pages/website/partner_marketing/unpaid/UnpaidView.vue'
import MarketingHistoryView from '@partner-spa-vue/pages/website/partner_marketing/history/HistoryView.vue'
import MarketingNotificationsView from '@partner-spa-vue/pages/website/partner_marketing/notifications/NotificationsView.vue'
import MarketingReportsView from '@partner-spa-vue/pages/website/partner_marketing/reports/ReportsView.vue'
// import { authState, waitUntilReady } from '@/ui-plus/useAuth';
// import { watch } from 'vue';
// import { useDialog } from '@/ui-plus/dialog/use-dialog'

const router = createRouter({
  scrollBehavior(_to, _from, _savedPosition) {
    if (_savedPosition) {
      return _savedPosition
    } else {
      return { top: 0 }
    }
  },
  history: createWebHashHistory("/"),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },



    // WEBSITE ROUTES
    {
      path: '/my-websites',
      name: 'my-websites',
      component: MyWebsitesView,
    },
    {
      path: '/new-website',
      name: 'new-website',
      component: WebsiteNewForm,
    },
    {
      path: '/website/:websiteId',
      name: 'website',
      component: WebsiteLayout,
      children: [
        {
          path: '',
          name: 'website-home',
          component: WebsiteHomeView,
        },
        {
          path: 'address',
          name: 'website-address',
          component: WebsiteAddressView,
        },
        {
          path: 'support-earnings',
          component: PartnerSupportView,
          children: [
            {
              path: '',
              name: 'support-earnings',
              component: SupportOverviewView,
            },
            {
              path: 'stripe',
              name: 'support-earnings-stripe',
              component: SupportStripeView,
            },
            {
              path: 'fee-settings',
              name: 'support-earnings-fee-settings',
              component: SupportFeeSettingsView,
            },
            {
              path: 'balances',
              name: 'support-earnings-balances',
              component: SupportBalancesView,
            },
            {
              path: 'incoming',
              name: 'support-earnings-incoming',
              component: SupportIncomingView,
            },
            {
              path: 'unpaid',
              name: 'support-earnings-unpaid',
              component: SupportUnpaidView,
            },
            {
              path: 'history',
              name: 'support-earnings-history',
              component: SupportHistoryView,
            },
            {
              path: 'reports',
              name: 'support-earnings-reports',
              component: SupportReportsView,
            },
            {
              path: 'notifications',
              name: 'support-earnings-notifications',
              component: SupportNotificationsView,
            },
            {
              path: 'imprint',
              name: 'support-earnings-imprint',
              component: SupportImprintView,
            },
          ],
        },
        {
          path: 'marketing-earnings',
          component: PartnerMarketingView,
          children: [
            {
              path: '',
              name: 'marketing-earnings',
              component: MarketingOverviewView,
            },
            {
              path: 'stripe',
              name: 'marketing-earnings-stripe',
              component: MarketingStripeView,
            },
            {
              path: 'fee-settings',
              name: 'marketing-earnings-fee-settings',
              component: MarketingFeeSettingsView,
            },
            {
              path: 'balances',
              name: 'marketing-earnings-balances',
              component: MarketingBalancesView,
            },
            {
              path: 'incoming',
              name: 'marketing-earnings-incoming',
              component: MarketingIncomingView,
            },
            {
              path: 'unpaid',
              name: 'marketing-earnings-unpaid',
              component: MarketingUnpaidView,
            },
            {
              path: 'history',
              name: 'marketing-earnings-history',
              component: MarketingHistoryView,
            },
            {
              path: 'reports',
              name: 'marketing-earnings-reports',
              component: MarketingReportsView,
            },
            {
              path: 'notifications',
              name: 'marketing-earnings-notifications',
              component: MarketingNotificationsView,
            },
          ],
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      redirect: { name: 'home' }
    }
  ],
  strict: true,
})

router.beforeEach((_to, _from, next) => {
  pageTitle.value = '';
  next()
})

// Handle chunk loading errors during navigation
router.onError((error) => {
  const message = error.message.toLowerCase() || error.toString().toLowerCase()

  // Check if it's a chunk loading error
  if (
    message.includes('loading chunk') ||
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('loading css chunk')
  ) {

    console.warn('Router chunk loading failed, dispatching custom event:', message)

    toast.error('An error occurred, please refresh the page now.')

  }
})

export default router
